<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16">
      <h1 class="cf-title cf-title--1">
        Payment Methods
      </h1>

      <cf-tabbed-routes
        :invalid-redirect-route="{
          name: 'orderMenu',
          params: {
            merchantId: $route.params.merchantId
          }
        }"
        :tabs="[
          {
            isValid: creditCardManagementEnabled,
            label: 'Credit Cards',
            route: {
              name: 'paymentMethodsCreditCards',
              params: {
                merchantId: $route.params.merchantId
              }
            }
          },
          {
            isValid: giftCardManagementEnabled,
            label: 'Gift Cards',
            route: {
              name: 'paymentMethodsGiftCards',
              params: {
                merchantId: $route.params.merchantId
              }
            }
          }
        ]"
      />

      <router-view />
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTabbedRoutes from '@/view/components/shared/cf-tabbed-routes/index.vue';


  export default {
    name: 'PaymentMethodsPage',

    components: {
      CfTabbedRoutes
    },

    metaInfo() {
      return {
        title: 'Payment Methods'
      };
    },

    computed: {
      ...mapGetters('giftCards', ['giftCardManagementEnabled']),
      ...mapGetters('savedCards', ['creditCardManagementEnabled'])
    }
  };
</script>
